export const numberToBengali = (number: number) => {
  return number
    .toString()
    .replace(/\d/g, (match) => String.fromCharCode(2534 + parseInt(match)));
};
